
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-745c481e!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./QueueStatusComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./QueueStatusComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-745c481e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./QueueStatusComponent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/QueueStatusComponent.vue
// module id = 232
// module chunks = 2